<template lang="pug">
v-flex 
  v-card
    v-card-title Métodos de pago
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar métodos de pago' single-line hide-details)
      v-dialog(v-model='PaymentMethods.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.description' label='Descripción')
                v-flex(xs12 sm6)
                  v-text-field(:rules='[rules.mustThree]' type='number' v-model='data.number' label='Número' mask='###')
                v-flex(xs12 sm6)
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items='PaymentMethodsRecord' :search='search')
      template(v-slot:items='props')
        td {{ props.item.description }}
        td {{ props.item.number }}
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editItem(props.item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Lista de métodos de pagos',
        align: 'left',
        value: 'description'
      },
      { text: 'Número', value: 'number' },
      { text: 'Actions', value: 'titlename', sortable: false }
    ],
    record: [],
  }),
    methods: {
      ...mapActions({
        editItem: 'PaymentMethods/get',
        deleteItem: 'PaymentMethods/clean',
        save: 'PaymentMethods/add',
        clearForm: 'PaymentMethods/clearForm',
      }),
    },
    computed: {
      title() { return this.PaymentMethods.selectedKey == '' ? 'Registar' : 'Crear' },
      titleButton() { return this.PaymentMethods.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        PaymentMethodsRecord: 'PaymentMethods/record',
      }),
       ...mapState({
      data: state=> state.PaymentMethods.data,
      PaymentMethods :state=> state.PaymentMethods,
      rules: state=>state.Helpers.rules
    })
  }
}
</script>
